import { VillaCollectionService } from './../../core/services/villa-collection.service';
import { getSortByOption, getBookingAction, getUserInfo,
        isRequestSendingEnabled } from './../../core/store/general/selectors';
import { HeaderChangeAction, ChangeLasteRequestAsked,
    ChangeHotelInfo, ChangeLoadingStatusAction, ToggleLoginModal, ChangeBookingAction } from './../../core/store/general/actions';
import { Injectable } from '@angular/core';
import { HotelPreview } from '../results/results.container';
import { Subject, Observable } from 'rxjs';
import { SharedContainer } from '../../shared/shared.container';
import { AddFacilityAction, AddRoomFacilityAction, AddExtraFacilityAction } from './../../core/store/search/actions';
import { ISearchFacilityGroup, FacilityState } from './../../core/models/search';
import { IFacility } from './../../core/models/facility';
import { SearchService } from './../../core/services/search.service';
import { getFacilities, getRoomFacilities, getExtraFacilities } from './../../core/store/search/selectors';
import { Store } from '@ngrx/store';



@Injectable()
export class VillaCollectionContainer {
    hotePreviews: Array<HotelPreview>;
    public hotelPrev = new Subject<Array<HotelPreview>>();
    public hotelPreviewsArr$ = this.hotelPrev.asObservable();
    experiencesIconsMapping;
    public mealTypes$;
    public hotelTypes$;
    public facilityGroups$: Array<ISearchFacilityGroup>;
    public roomFacilities$: Array<ISearchFacilityGroup>;
    public extras$: Array<ISearchFacilityGroup>;

constructor(private villaCollectionService: VillaCollectionService,
        private sharedContainer: SharedContainer,
        protected searchAPI: VillaCollectionService,
        protected searchState$: Store<FacilityState>
        ) {
        this.experiencesIconsMapping =  new Map([
            [1, '../../../../assets/img/icons/leisure.svg'],
            [2, '../../../../assets/img/icons/beach-sun.svg'],
            [3, '../../../../assets/img/icons/relax.svg'],
            [4, '../../../../assets/img/icons/family.svg'],
            [5, '../../../../assets/img/icons/budget-save-sun.svg'],
            [6, '../../../../assets/img/icons/luxury.svg'],
            [7, '../../../../assets/img/icons/local-gastronomy.svg'],
            [8, '../../../../assets/img/icons/local-culture.svg'],
            [9, '../../../../assets/img/icons/Experience-local-way-of-life.svg'],
            [10, '../../../../assets/img/icons/spa-wellness.svg'],
            [11, '../../../../assets/img/icons/Beauty-services.svg'],
            [12, '../../../../assets/img/icons/romance.svg'],
            [13, '../../../../assets/img/icons/wedding.svg'],
            [14, '../../../../assets/img/icons/anniversary.svg'],
            [15, '../../../../assets/img/icons/bussiness-travel.svg'],
            [16, '../../../../assets/img/icons/conference.svg'],
            [17, '../../../../assets/img/icons/exhibitions.svg'],
            [18, '../../../../assets/img/icons/nightlife.svg'],
            [19, '../../../../assets/img/icons/car-moto-hire.svg'],
            [20, '../../../../assets/img/icons/taxi.svg'],
            [21, '../../../../assets/img/icons/tours.svg'],
            [22, '../../../../assets/img/icons/water-sports.svg'],
            [23, '../../../../assets/img/icons/outdoor-activities.svg'],
            [24, '../../../../assets/img/icons/Archeological-sights.svg'],
            [25, '../../../../assets/img/icons/nature-parks.svg'],
            [26, '../../../../assets/img/icons/shopping.svg'],
            [27, '../../../../assets/img/icons/events-concerts.svg'],
            [28, '../../../../assets/img/icons/classes-workshops.svg'],
            [29, '../../../../assets/img/icons/agricultural-experience.svg'],
            [30, '../../../../assets/img/icons/casino-Gambling.svg'],
            [31, '../../../../assets/img/icons/Zoos-Aquariums.svg'],
            [32, '../../../../assets/img/icons/medical-tourism.svg'],
          ]);
          this.hotePreviews = new Array();
          this.hotelTypes$ = new Map<number, string>();
          this.mealTypes$ = new Map<number, string>();

          this.facilityGroups$ = new Array<ISearchFacilityGroup>();
          searchAPI.getFacilities()
            .subscribe( (facilitiesInfo: Array<any>) => {
              const facilities =  this.populateFacilities(facilitiesInfo, 'facilitiesCollection');
              this.searchState$.dispatch(new AddFacilityAction({ facilities: facilities }));
 });
          this.roomFacilities$ = new Array<ISearchFacilityGroup>();
          searchAPI.getRoomFacilities()
            .subscribe( (facilitiesInfo: Array<any>) => {
              this.searchState$.dispatch(new AddRoomFacilityAction({
                facilities: this.populateFacilities(facilitiesInfo, 'roomPropertyCollection')
              }));
            });

          this.extras$ = new Array<ISearchFacilityGroup>();
          searchAPI.getOptionalCategories()
            .subscribe( (extraFacilities: Array<any>) => {
              this.createExtrasModel(extraFacilities);
              this.searchState$.dispatch(new AddExtraFacilityAction({
                facilities: this.createExtrasModel(extraFacilities)
            }));
          });


          this.searchState$.select(getFacilities)
            .subscribe(arg => {
              for (const [key, value] of Object.entries(arg['entities'])) {
                this.facilityGroups$.push(this.populateFacility(value));
              }
            });

          this.searchState$.select(getRoomFacilities)
          .subscribe(arg => {
            for (const [key, value] of Object.entries(arg['entities'])) {
              this.roomFacilities$.push(this.populateFacility(value));
            }
});
          this.searchState$.select(getExtraFacilities)
          .subscribe(arg => {
            for (const [key, value] of Object.entries(arg['entities'])) {
              this.extras$.push(this.populateFacilityExtra(value));
            }
          });


    }

    retrieveVillaCollection() {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, {isLoading: true}));
        this.villaCollectionService.getVillaCollection().subscribe(villas => {
            this.storeVillaCollection(villas);
            // console.log(villas);
            this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, {isLoading: false}));
        });
    }

    retrieveVillaPreviewCollection(offset: number, limit: number) {
        this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, {isLoading: true}));
        this.villaCollectionService.getVillaPreviewCollection(offset, limit).subscribe(villas => {

            for (let i = 0; i < villas.length; i++) {
                this.fillPreviewMealTypes(villas[i].mealTypes);
                // f this is only Villas, so probably don't want this
                // f this.fillHotelTypes(villas[i].hotel.hotelAccommocationTypeCollection);
                if (villas[i].pictures.length  < 1) { continue; }
                // f convert string[] to object[] so we can add preloaded value
                for (let x = 0; x < villas[i].pictures.length; x++) {
                    villas[i].pictures[x] = {pictureThumbnailUrl: villas[i].pictures[x]};
                }
                villas[i].pictures[0].preloaded = true; // f load first image only
                this.hotePreviews.push(this.fillHotelPreview(villas[i]));
            }
            this.hotelPrev.next(this.hotePreviews);

            console.log(villas);
            this.sharedContainer.generalState$.dispatch(new ChangeLoadingStatusAction(1, {isLoading: false}));
        });
    }

    fillPreviewMealTypes(mealTypes) {
        const mealtypes = new Map(); // for a single hotel
        if (mealTypes === null || mealTypes === undefined) { return mealtypes; }
        mealTypes.map( mealType => {
                if (!this.mealTypes$.has(mealType.id)) {
                    this.mealTypes$.set( mealType.id, mealType.mealType);
                }
                if (!mealtypes.has(mealType.id)) {
                    mealtypes.set( mealType.id, mealType.mealType);
                }
            }
        );
        return mealtypes;
    }

    fillMealTypes(mealTypes) {
        const mealtypes = new Map(); // for a single hotel
        if (mealTypes === null || mealTypes === undefined) { return mealtypes; }
        mealTypes.map( accomodation => {
                if (!this.mealTypes$.has(accomodation.mealType.id)) {
                    this.mealTypes$.set( accomodation.mealType.id, accomodation.mealType.mealType);
                }
                if (!mealtypes.has(accomodation.mealType.id)) {
                    mealtypes.set( accomodation.mealType.id, accomodation.mealType.mealType);
                }
            }
        );
        return mealtypes;
    }

    fillHotelTypes(accommodationTypes) {
        const hotelTypes = new Map(); // for a single hotel
        if (accommodationTypes === null || accommodationTypes === undefined) { return hotelTypes; }
        accommodationTypes.map( accomodation => {
                if (!this.hotelTypes$.has(accomodation.accommodationType.id)) {
                    this.hotelTypes$.set( accomodation.accommodationType.id, accomodation.accommodationType.name);
                }
                if (!hotelTypes.has(accomodation.accommodationType.id)) {
                    hotelTypes.set( accomodation.accommodationType.id, accomodation.accommodationType.name);
                }
            }
        );
        return hotelTypes;
    }

    storeVillaCollection(villas) {
        villas.sort( (a, b) => {
            const isAVilla = a.hotel.hotelAccommocationTypeCollection.find(accType => {
                if (accType.accommodationType.id === 3) { // is Villa?
                    return true;
                }
                return false;
            });
            // console.log(isAVilla);
            const isBVilla = b.hotel.hotelAccommocationTypeCollection.find(accType => {
                if (accType.accommodationType.id === 3) { // is Villa?
                    return true;
                }
                return false;
            });
            if (isAVilla && !isBVilla) {
                return -1;
            } else if (!isAVilla && isBVilla) {
                return 1;
            }
            if (a.extras.length > b.extras.length) {
                return -1;
            } else if (a.extras.length < b.extras.length) {
                return 1;
            }
            return 0;
        });
        for (let i = 0; i < villas.length; i++) {
            this.fillMealTypes(villas[i].hotel.hotelMealCollection);
            this.fillHotelTypes(villas[i].hotel.hotelAccommocationTypeCollection);
            console.log(villas[i].hotelMealCollection);
            // this.fillFilterOptions(offer);
            // this.fillRequestInfo(offer.offer.bookingRequest);
            // this.fillSelectedExperiences();
            if (villas[i].propertyPics.length  < 1) { continue; }
            this.hotePreviews.push(this.fillHotelPreviewInfo(villas[i]));
            // this.sortByPrice('ASC');
            // this.sortByExperiences();
            // this.bookingRequest = offer.offer.bookingRequest;

            // this.fillMarkers(offer.hotel);
        }
        this.hotelPrev.next(this.hotePreviews);
        // this.markersSubj.next(this.markers);
    }

    fillHotelPreviewInfo(villa): HotelPreview {
        const hotelPreview: HotelPreview = {
            minPrice: 10000,
            minDefaultPrice: 10000,
            title: '',
            description: '',
            pictures: [],
            stars: -1,
            reviews: 0,
            experiences: [],
            experiencesSortByAPrice: [],
            optionaRequests: [],
            id: -1,
            offerId: -1,
            offerType: '',
            experiencesAvailable: '',
            optionalAvailable: '',
            hasDiscount: false
        };
        hotelPreview.lat = villa.hotel.latitude;
        hotelPreview.long = villa.hotel.longitude;
        hotelPreview.title = villa.hotel.name;
        hotelPreview.stars = villa.hotel.starRating;
        hotelPreview.reviews = villa.reviews;
        hotelPreview.pictures = villa.propertyPics.filter(pics => pics.pictureUrl !== null);
        hotelPreview.experiences = villa.extras;
        hotelPreview.id = villa.hotel.id;



        hotelPreview.experiences.forEach(experience => {
            if (experience.optionalExtraCategory) {
                experience.icon = this.experiencesIconsMapping.get(experience.optionalExtraCategory.id);
            } else {
                experience.icon = this.experiencesIconsMapping.get(12);
            }

        });

        hotelPreview.experiences.sort((a, b) => {
            if (a.hasTick === true && b.hasTick === false) {
                return -1;
            }

            if (a.hasTick === false && b.hasTick === true) {
                return 1;
            }

            return 0;
        });
        hotelPreview.experiencesSortByAPrice = JSON.parse(JSON.stringify(hotelPreview.experiences));

        hotelPreview.experiencesSortByAPrice.sort((a, b) => {
            if (a.isFree === true && b.isFree === false) {
                return -1;
            }

            if (a.isFree === false && b.isFree === true) {
                return 1;
            }

            if (a.isCategoryMeal === true && b.isCategoryMeal === false) {
                return -1;
            }
            if (a.isCategoryMeal === false && b.isCategoryMeal === true) {
                return 1;
            }

            return 0;
        });


        // hotelPreview.hotelTypes = this.fillHotelTypes(offer.hotel.hotelAccommocationTypeCollection);
        // hotelPreview.mealTypes = this.fillMealTypes(offer.hotel.hotelMealCollection);
        // hotelPreview.exclusiveCategories = this.fillExclusiveCategories(offer.offer.bookingOfferOptionalExtrasCollection);
        // hotelPreview.optionalFacilities = this.fillOptionalFacilities(offer.offer.bookingOfferFacilitiesCollection);
        return hotelPreview;
    }

    fillHotelPreview(villa): HotelPreview {
        const hotelPreview: HotelPreview = {
            minPrice: 10000,
            minDefaultPrice: 10000,
            title: '',
            description: '',
            pictures: [],
            stars: -1,
            reviews: 0,
            experiences: [],
            experiencesSortByAPrice: [],
            optionaRequests: [],
            id: -1,
            offerId: -1,
            offerType: '',
            experiencesAvailable: '',
            optionalAvailable: '',
            hasDiscount: false
        };
        hotelPreview.lat = villa.lat;
        hotelPreview.long = villa.lon;
        hotelPreview.title = villa.title;
        hotelPreview.stars = villa.stars;
//        hotelPreview.reviews = villa.reviews; // f not used
        hotelPreview.pictures = villa.pictures;
        hotelPreview.experiences = villa.experiences;
        hotelPreview.id = villa.id;



        hotelPreview.experiences.forEach(experience => {
            if (experience.optionalExtraCategory) {
                experience.icon = this.experiencesIconsMapping.get(experience.optionalExtraCategory.id);
            } else {
                experience.icon = this.experiencesIconsMapping.get(12);
            }

        });

        hotelPreview.experiences.sort((a, b) => {
            if (a.hasTick === true && b.hasTick === false) {
                return -1;
            }

            if (a.hasTick === false && b.hasTick === true) {
                return 1;
            }

            return 0;
        });

        hotelPreview.experiencesSortByAPrice = hotelPreview.experiences; // f why not use the same collection?
        return hotelPreview;
    }

    getHotelPreviews() {
        return this.hotePreviews;
    }

    getSingleVillaInfo(villaid): Observable<any> {
        return this.villaCollectionService.getVillaInformation(villaid);
    }

    getVillaPictures(villaid): Observable<any> {
        return this.villaCollectionService.getVillaPictures(villaid);
    }

    getVillaExperiences(villaid): Observable<any> {
        return this.villaCollectionService.getVillaExperiences(villaid);
    }



    sendRequest(data) {
        return this.searchAPI.sendRequest(data);
      }


      populateFacility(value) {
        const facility: ISearchFacilityGroup = {
          id: value['id'],
          name: value['name'],
          facilities: value['facilities']
        };
        return facility;
      }

      populateFacilityExtra(value) {
        const facility: ISearchFacilityGroup = {
          id: value['id'],
          name: value['name'],
          facilities: value['facilities'],
        };
        return facility;
      }

      createExtrasModel(extraFacilities) {
        const facilities: Array<IFacility> = extraFacilities.map(fac => {
          const faci: IFacility = { id: fac.id, title: fac.category, isChecked: false };
          return faci;
        });
        const facilityGroup: ISearchFacilityGroup = {
          id: 1,
          name: 'extras',
          facilities: facilities
        };

        return facilityGroup;
      }

      populateFacilities(facilitiesInfo, collectionTitle) {
        const facilitiesArr: Array<ISearchFacilityGroup> = new Array();
        for (const fetchedFacility of facilitiesInfo) {
          const facilities: Array<IFacility> = fetchedFacility[collectionTitle].map(fac => {
            const faci: IFacility = { id: fac.id, title: fac.name, isChecked: false };
            return faci;
          });
          const facility: ISearchFacilityGroup = {
            id: fetchedFacility['id'],
            name: fetchedFacility['groupName'],
            facilities: facilities
          };
          facilitiesArr.push(facility);
        }

        return facilitiesArr;
      }


}
